import {
  Box,
  Button,
  Dialog,
  Grid,
  Menu,
  MenuProps,
  Stack,
  Typography,
  Drawer,
  Tabs,
  Tab,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DataPipelineModal } from './modal-component';
import { ReactComponent as EditIcon } from '../../assets/edit-img.svg';
import { ReactComponent as DeleteIcon } from '../../assets/delete-img.svg';
import { ReactComponent as AddIcon } from '../../assets/plus-icon.svg';
import { ReactComponent as ClockIcon } from '../../assets/time-history.svg';
import './dataPipeline.scss';
import CyclicExecutions from './CyclicExecutions';
import SLAHistory from './SLAHistory';
import {
  exportGetMappedJobScheduleList,
  getAddedSchedules,
  getDependentJobExeData,
  getMappedJobScheduleList,
  getProjectById,
  postJobComment,
} from '../../service/service';
import { CustomizedDataGrid } from '../customized_data_grid';
import { Column } from 'react-data-grid';
import Loader from '../Loader/loader';
import moment from 'moment';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { styled, alpha, useTheme } from '@mui/material/styles';
import 'react-day-picker/dist/style.css';
import { CellExpanderFormatter } from 'components/cell_expander_formatter';
import DataInfoSecondary from 'components/Widgets/DataInfoSecondary';
import ShowInfoWidget from 'components/Widgets/ShowInfoWidget';
import PageHeader from 'components/Header/Page';
import DashboardIcon from '../../assets/material-symbols_dashboard.svg';
import DataInfoColorWidget from 'components/Widgets/DataInfoColorWidget';
import ReactDateRangeFilter from 'components/Dropdown/ReactDateRangeFilter';
import StatusChip from 'components/Table/StatusChip';
import RowTypography from 'components/Table/RowTypography';
import eventEmitter from 'SnackBarEventEmitter';
import { dependInfoTransformData, getHrsMinPlatformId } from 'utils/common-util';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import RagBar from 'components/Table/RagBar';
import { checkRole } from 'utils/roleUtils';
import { getDefaultColumnNamesExec, getKindFromPlatformId, getPlatformLabels } from 'utils/platformLabelUtil';
import PageWrapper from 'components/Common/PageWraper';
import { PLATFORM_ID_TO_NAME } from './constant';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

type EditableCellProps = {
  jobId: any;
  jobExeId: any;
  projectId: any;
  comment: string;
  platformId: any;
  isAllowed: boolean;
  textColor: any;
  rowData: any;
  onSave: (
    text: string,
    jobId: any,
    jobExeId: any,
    projectId: any,
    platformId: any,
    rowData: any,
  ) => Promise<void>;
};

const EditableCell = ({
  jobId,
  jobExeId,
  projectId,
  comment,
  platformId,
  isAllowed,
  textColor,
  onSave,
  rowData,
}: EditableCellProps) => {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(comment ?? '');

  const displayText = text.length > 20 ? `${text.substring(0, 20)}...` : text;

  const isEditableStatus =
    rowData?.jobStatus === 'Success' || 
    rowData?.jobStatus === 'Failed' ||
    rowData?.jobStatus === 'Successful' ||
    rowData?.jobStatus === 'Failure' ||
    rowData?.jobStatus?.toLowerCase() === 'succeeded';

  const handleEditClick = () => {
    setEditing(true);
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return;

    setEditing(false);
    await onSave(text, jobId, jobExeId, projectId, platformId, rowData);
  };

  return (
    <Stack direction="row" alignItems="center" height="100%" justifyContent="flex-end">
      {editing ? (
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Write here..."
          style={{
            flexGrow: 1,
            textAlign: 'left',
            paddingLeft: 1,
            background: '#003771',
            color: 'white',
          }}
          onBlur={() => setEditing(false)}
          disabled={!rowData?.actualStartTime || !isEditableStatus}
          onKeyDown={handleKeyDown}
          autoFocus
        />
      ) : (
        <span
          style={{
            flexGrow: 1,
            textAlign: 'left',
            paddingLeft: 5,
            color: `${textColor} !important`,
            opacity: text ? 1 : 0.6,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '150px',
            display: 'inline-block',
          }}
          title={text}
        >
          {text ? displayText : 'Write here...'}
        </span>
      )}

      {isAllowed && <EditIcon style={{ cursor: 'pointer' }} onClick={handleEditClick} />}
    </Stack>
  );
};

const platformIdFormatter = () => {
  return ({ row }: any) => {
    let platformLabel = ' - ';

    if (row.application === 'SAPS4H_AME') {
      platformLabel = 'S4';
    } else if (row.application === 'SAPENTHANA') {
      platformLabel = 'EHANA';
    } else if (row.platformId) {
      platformLabel = PLATFORM_ID_TO_NAME[row.platformId];
    }

    return <RowTypography isSuccessor={!row.dependentData}>{platformLabel}</RowTypography>;
  };
};

const adfNameFormatter = () => {
  return ({ row }: any) => {
    const adfName = row.adfName ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{adfName}</RowTypography>;
  };
};

const workspaceNameFormatter = () => {
  return ({ row }: any) => {
    const workspaceName = row.workspaceName?.trim() ?? '--';

    return (
      <RowTypography textTransform="capitalize" title={workspaceName}>
        {workspaceName}
      </RowTypography>
    );
  };
};

const jobNameFormatter = (
  toggleSubRow: (id: number, dependentData: any, eleLevel: string) => void,
) => {
  return ({ row, isCellSelected }: any) => {
    const hasChildren = Boolean(row.hasDependent);

    const isAutosys =
      String(row.platform || '')
        .toLowerCase()
        .endsWith('autosys');

    const showExpander = isAutosys
      ? hasChildren
      : (hasChildren || (row.platformId !== 10 && row.lineageJobRunId));

    const className = [
      row.className,
      row.eleLevel,
      row.jobStatus,
      row.isChildren ? 'child-view' : 'parent-view',
      hasChildren ? 'has-children' : 'single',
    ].join(' ');

    return (
      <div className={className}>
        {showExpander && (
          <CellExpanderFormatter
            isCellSelected={isCellSelected}
            expanded={row.isExpanded === true}
            onCellExpand={() => toggleSubRow(row.id, row.dependentData, row.eleLevel)}
          />
        )}
        {'   '}
        <RowTypography isSuccessor={!row.dependentData} title={row.jobName}>
          {row.jobName ?? '--'}
        </RowTypography>
      </div>
    );
  };
};


const sourceTableFormatter = () => {
  return ({ row }: any) => {
    const sourceTableObj = row.sourceTable;

    function formatSourceTable(obj: any) {
      if (!obj || typeof obj !== 'object') return '--';

      return Object.entries(obj)
        .map(([outerKey, innerValue]) => {
          // Case 1: innerValue is another object
          if (innerValue && typeof innerValue === 'object') {
            const innerFormatted = Object.entries(innerValue)
              .map(([key, value]) => `${key}: ${value}`)
              .join(', ');

            return `${outerKey} → ${innerFormatted}`;
          }

          // Case 2: innerValue is a string
          return `${outerKey}: ${innerValue}`;
        })
        .join(' | ');
    }

    const displayValue = formatSourceTable(sourceTableObj);

    return (
      <RowTypography textTransform="capitalize" title={displayValue}>
        {displayValue}
      </RowTypography>
    );
  };
};

const targetTableFormatter = () => {
  return ({ row }: any) => {
    let targetTable = '--';
    if (row.targetTable && typeof row.targetTable === 'object' && !Array.isArray(row.targetTable)) {
      targetTable = Object.keys(row.targetTable).length
        ? Object.entries(row.targetTable).map(([k, v]) => `${k}: ${v}`).join(', ')
        : '--';
    }

    if (typeof row.targetTable === 'string' && row.targetTable.trim()) {
      targetTable = row.targetTable.trim();
    }

    return (
      <RowTypography textTransform="capitalize" title={targetTable}>
        {targetTable}
      </RowTypography>
    );
  };
};

const jobRunUrlFormatter = () => {
  return ({ row }: any) => {
    const jobRunUrl = row.jobRunUrl ?? '--';

    if (jobRunUrl === '--') {
      return <RowTypography isSuccessor={!row.hasDependent}>{jobRunUrl}</RowTypography>;
    }

    return (
      <Link
        to={jobRunUrl}
        target="_blank"
        state={row}
        style={{ textDecoration: 'underline', color: '#BCBCBC' }}
      >
        <RowTypography isSuccessor={!row.hasDependent} title={jobRunUrl}>
          {jobRunUrl}
        </RowTypography>
      </Link>
    );
  };
};

export const runFileFormatter = () => {
  return ({ row }: any) => {
    const runFile = row.runFile?.trim() ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{runFile}</RowTypography>;
  };
};

export const filepathFormatter = () => {
  return ({ row }: any) => {
    const filePath = row.filePath?.trim() ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{filePath}</RowTypography>;
  };
};

export const kindFormatter = () => {
  return ({ row }: any) => {
    const kind = getKindFromPlatformId(row.platformId);
    
    return <RowTypography isSuccessor={!row.dependentData}>{kind}</RowTypography>;
  };
};

export const triggerNameFormatter = () => {
  return ({ row }: any) => {
    const triggerName =
      row.triggerName && row.triggerName !== 'manual' && row.triggerName !== 'all'
        ? row.triggerName
        : '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{triggerName}</RowTypography>;
  };
};

export const dataAssetNameFormatter = () => {
  return ({ row }: any) => {
    const dataAssetName = row.dataAssetName?.trim() ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{dataAssetName}</RowTypography>;
  };
};

export const silverTableNameFormatter = () => {
  return ({ row }: any) => {
    const silverTableName = row.silverTableName?.trim() ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{silverTableName}</RowTypography>;
  };
};

export const folderNamesFormatter = () => {
  return ({ row }: any) => {
    const folderNames = row.folderNames?.trim() ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{folderNames}</RowTypography>;
  };
};

export const subFolderNamesFormatter = () => {
  return ({ row }: any) => {
    const subFolderNames = row.subFolderNames?.trim() ?? '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{subFolderNames}</RowTypography>;
  };
};

export const scheduleInfoFormatter = () => {
  return ({ row }: any) => {
    const scheduleInfo = row.scheduleInfo || '--';

    return <RowTypography isSuccessor={!row.hasDependent}>{scheduleInfo}</RowTypography>;
  };
};

export const jobRunIdFormatter = () => {
  return ({ row }: any) => {
    const jobRunId = row.jobRunId || '--';
    const hasLink = Boolean(row.adfUrl);
    const isSuccessor = !row.hasDependent;

    const typography = (
      <RowTypography isSuccessor={isSuccessor} title={jobRunId}>
        {jobRunId}
      </RowTypography>
    );

    if (!hasLink) {
      return typography;
    }

    return (
      <Link
        to={row.adfUrl}
        target="_blank"
        state={row}
        style={{
          textDecoration: 'underline',
          ...(row.hasDependent ? {} : { color: '#BCBCBC' }),
        }}
      >
        {typography}
      </Link>
    );
  };
};

export const runIdFormatter = () => {
  return ({ row }: any) => {
    const jobRunId = row.jobRunId || '--';

    return <RowTypography title={jobRunId}>{jobRunId}</RowTypography>;
  };
};

export const stepIdFormatter = () => {
  return ({ row }: any) => {
    const stepId = row.stepId ?? '--';

    return <RowTypography title={stepId}>{stepId}</RowTypography>;
  };
};

export const stepNameFormatter = () => {
  return ({ row }: any) => {
    const stepName = row.stepName?.trim() ?? '--';

    return <RowTypography title={stepName}>{stepName}</RowTypography>;
  };
};

export const jobStatusFormatter = () => {
  return ({ row }: any) => {
    let status = row.jobStatus;

    if (row.jobStatus === 'Successful' || row.jobStatus?.toLowerCase() === 'succeeded') {
      status = 'Success';
    } else if (row.jobStatus === 'Failure') {
      status = 'Failed';
    }

    return <StatusChip status={status} columnName="jobStatus" />;
  };
};

export const jobConditionFormatter = () => {
  return ({ row }: any) => {
    let condition = '--';

    if (row.jobCondition === 'A') {
      condition = 'AND';
    } else if (row.jobCondition === 'O') {
      condition = 'OR';
    }

    return <RowTypography isSuccessor={!row.hasDependent}>{condition}</RowTypography>;
  };
};

export const orderDateFormatter = () => {
  return ({ row }: any) => {
    const startDate = row.orderDate;

    return (
      <RowTypography isSuccessor={!row.dependentData}>
        {' '}
        {startDate ? moment(startDate).utc().format('MM-DD-YY') : '--'}{' '}
      </RowTypography>
    );
  };
};

export const actualStartTimeFormatter = () => {
  return ({ row }: any) => {
    const startDate = row.actualStartTime;
    const isValidStatus = row.jobStatus !== 'Scheduled' && row.jobStatus !== 'Not Scheduled';

    return (
      <RowTypography isSuccessor={!row.hasDependent}>
        {' '}
        {startDate && startDate != null && isValidStatus
          ? moment(startDate).tz('America/Chicago').format('MM-DD-YY HH:mm:ss')
          : '--'}{' '}
      </RowTypography>
    );
  };
};

export const actualStartTimeFormatterCustom = () => {
  return ({ row }: any) => {
    const startDate = row.actualStartTime;

    return (
      <RowTypography isSuccessor={!row.dependentData}>
        {' '}
        {startDate && startDate != null
          ? moment(startDate).tz('America/Chicago').format('MM-DD-YY HH:mm:ss')
          : '--'}{' '}
      </RowTypography>
    );
  };
};

export const actualEndTimeFormatter = () => {
  return ({ row }: any) => {
    const endDate = row.actualEndTime;
    const isValidStatus =
      row.jobStatus !== 'Scheduled' &&
      row.jobStatus !== 'Not Scheduled' &&
      row.jobStatus !== 'Long Running' &&
      row.jobStatus !== 'Failed To Start' &&
      row.jobStatus !== 'Delayed';

    return (
      <RowTypography isSuccessor={!row.hasDependent}>
        {' '}
        {endDate && isValidStatus
          ? moment(endDate).tz('America/Chicago').format('MM-DD-YY HH:mm:ss')
          : '--'}{' '}
      </RowTypography>
    );
  };
};

export const actualEndTimeFormatterCustom = () => {
  return ({ row }: any) => {
    const endDate = row.actualEndTime;

    return (
      <RowTypography isSuccessor={!row.dependentData}>
        {' '}
        {endDate ? moment(endDate).tz('America/Chicago').format('MM-DD-YY HH:mm:ss') : '--'}{' '}
      </RowTypography>
    );
  };
};


export const avgRunTimeFormatter = () => {
  return ({ row }: any) => {
    const hasAvgRunTime = Boolean(row.avgRunTime);
    const isValidStatus =
      row.jobStatus !== 'Scheduled' &&
      row.jobStatus !== 'Not Scheduled';
    // If adfName exists, do not divide avgRunTime by 6000, else divide it
    let avgRunTimeValue = Number(row.avgRunTime);
    if (!row?.adfName) {
      avgRunTimeValue = Number(avgRunTimeValue / 60000);
    }

    return (
      <RowTypography isSuccessor={!row.hasDependent}>
        {hasAvgRunTime && isValidStatus
          ? getHrsMinPlatformId(
            avgRunTimeValue,
            row.platformId
          )
          : '--'}
      </RowTypography>
    );
  };
};

export const avgRunTimeFormatterCustom = () => {
  return ({ row }: any) => {
    const avgRunTime = row.avgRunTime;

    return (
      <RowTypography isSuccessor={!row.dependentData}>
        {avgRunTime
          ? getHrsMinPlatformId(
            Number(avgRunTime),
            row.platformId
          )
          : '--'}
      </RowTypography>
    );
  };
};

export const totalExecutionsFormatter = (fetchCyclicExecutions: (row: any) => void) => {
  return ({ row }: any) => {
    if (!row.totalExecutions) {
      return <div style={{ textAlign: 'center' }}>--</div>;
    }



    const isRunnable =
      row.jobStatus !== 'Scheduled' && row.jobStatus !== 'Not Scheduled' && row.totalExecutions > 1 && !row.isPredecessor;

    const exeValue = row.totalExecutions ? row.totalExecutions : '--';
    const displayValue =
      row.jobStatus === 'Not Scheduled' ||
        row.jobStatus === 'Scheduled' ||
        row.jobStatus === 'Failed To Start'
        ? 0
        : exeValue;

    return (
      <Grid
        container
        spacing={1}
        onClick={isRunnable ? () => fetchCyclicExecutions(row) : undefined}
        style={{ cursor: row.totalExecutions > 1 && !row.isPredecessor ? 'pointer' : 'default' }}
      >
        <Grid item xs={6}>
          <StatusChip
            displayNumber
            columnName="totalExecutions"
            status="IP_Delayed_Start"
            value={displayValue}
          />
        </Grid>

        <Grid item xs={4} />

        {isRunnable && (
          <Grid
            item
            xs={2}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <ClockIcon onClick={() => fetchCyclicExecutions(row)} />
          </Grid>
        )}
      </Grid>
    );
  };
};

export const totalExecutionsFormatterCustom = (fetchCyclicExecutions: (row: any) => void) => {
  return ({ row }: any) => {
    if (!row.totalExecutions) {
      return <div style={{ textAlign: 'center' }}>--</div>;
    }

    const isClickable = row.totalExecutions > 1 && !row.isPredecessor;

    const exeValue = row.totalExecutions ? row.totalExecutions : '--';
    const displayValue =
      row.jobStatus === 'Not Scheduled' ||
        row.jobStatus === 'Scheduled' ||
        row.jobStatus === 'Failed To Start'
        ? 0
        : exeValue;

    return (
      <Grid
        container
        spacing={1}
        onClick={isClickable ? () => fetchCyclicExecutions(row) : undefined}
        style={{ cursor: isClickable && !row.isPredecessor ? 'pointer' : 'default' }}
      >
        <Grid item xs={6}>
          <StatusChip
            displayNumber
            columnName="totalExecutions"
            status="IP_Delayed_Start"
            value={displayValue}
          />
        </Grid>

        <Grid item xs={4} />

        {isClickable && (
          <Grid
            item
            xs={2}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <ClockIcon onClick={() => fetchCyclicExecutions(row)} />
          </Grid>
        )}
      </Grid>
    );
  };
};

export const ragBarFormatter = () => {
  return ({ row }: any) => {
    const execStatusTrend = row.execStatusTrend ?? '';

    return <RagBar colors={getColorData(execStatusTrend)} />;
  };
};

export const oDateFormatter = () => {
  return ({ row }: any) => {
    const startDate = row.oDate;

    if (!startDate) {
      return '';
    }

    return (
      <RowTypography isSuccessor={!row.dependentData}>
        {' '}
        {startDate ? moment(startDate).utc().format('MM-DD-YY') : '--'}{' '}
      </RowTypography>
    );
  };
};

export const isCyclicFormatter = () => {
  return ({ row }: any) => {
    let cyclicValue = row.isCyclic;

    if (row.isCyclic === '0') {
      cyclicValue = 'No';
    } else if (row.isCyclic === '1') {
      cyclicValue = 'Yes';
    }

    return <RowTypography isSuccessor={!row.dependentData}>{cyclicValue}</RowTypography>;
  };
};

const getColorData = (data: string) => {
  let colorArr: string[] = [];
  const arr = data.split(',').map(Number);

  arr.forEach((value: number) => {
    switch (value) {
      case 1:
        colorArr.push('rgba(1, 192, 8, 1)'); // Success Color
        break;
      case 2:
        colorArr.push('rgba(216, 43, 81, 1)'); // Failed color
        break;
      case 3:
        colorArr.push('rgba(236, 185, 20, 1)'); // Inprogress Color
        break;
      case 4:
        colorArr.push('rgba(253, 149, 50, 1)'); // LongRunning Color
        break;
      case 5:
        colorArr.push('rgba(255, 56, 176, 1)'); // Delayed Color
        break;
      case 7:
        colorArr.push('rgba(255, 118, 118, 1)'); // Scheduled Color
        break;
      default:
        break;
    }
  });

  return colorArr;
};

const ProjectDetails = () => {
  const theme = useTheme();
  interface Row {
    id: number;
    orderDate: any;
    jobId: number;
    jobName: string;
    kind: string;
    dependentData: any;
    scheduler?: string;
    jobStatus: string;
    oDate: string;
    actualStartTime: string;
    actualEndTime: string;
    slaStatus: string;
    slaTime: number;
    isExpanded: boolean;
    ischildren?: boolean;
    children: Row[];
    platformId: number;
    slaDate: string;
    hasDependent: boolean;
    className: string;
    eleLevel: string;
    isChildren?: boolean;
    exeId?: number;
    jobCondition: string;
    scheduleInfo: string;
    isCyclic: string;
    depCyclic: string;
    avgRunTime: any;
    totalExecutions: number;
    application: string;
    subapplication: string;
    folderNames: string;
    subFolderNames: string;
    triggerName?: string;
    adfName?: string;
    jobRunId?: string;
    adfUrl?: string;
    silverTableName?: string;
    dataAssetName?: string;
    runFile?: string;
    filePath?: string;
    workspaceName?: string;
    sourceTable?: string;
    targetTable?: string;
    platformName?: string;
  }
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const startingDateParam = searchParams.get('startingDate');
  const endingDateParam = searchParams.get('endingDate');
  const dateFilterParam = searchParams.get('dateFilter');

  const [widgetJobStatus, setWidgetJobStatus] = useState<string | null>(searchParams.get('jobStatus'));

  const { programId, projectId, program, project} = useParams();

  const [controller] = usePepwiseAuthController();
  const { role } = controller;
  const isAllowed = checkRole(role, ['Data Operations Admin', 'PepWise System User']);

  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const [clickedItem, setClickedItem] = useState<string | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  const handleMenuClose = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const [nameFilObj, setNameFilObj] = useState<any>({});
  const [openModal, setOpenModal] = useState<any>({ isOpen: false });
  const [projectDetail, setProjectDetail] = useState<any>({});
  const [slaStatus, setSlaStatus] = useState<any>('');
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [kpiLoading, setKpiLoading] = useState(false);
  const [dependentInfoLoading, setDependentInfoLoading] = React.useState<boolean>();
  const [jobSchedulesList, setjobSchedulesList] = useState<Row[]>([]);
  const [addedJobsList, setAddedJobsList] = useState<Row[]>([]);
  const [jobExeList, setJobExeList] = useState<Row[]>([]);
  const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
  const [filterInfo, setFilterInfo] = useState({
    jobStatus: ['Success', 'Failed', 'Long Running', 'In Progress', 'Scheduled', 'Failed To Start'],
  });
  const [platformName, setPlatformName] = useState<any>('ADF');
  const [filterOptions, setFilterOptions] = useState<any>({});
  const [slaReport, setSlaReport] = useState<any>({});
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
  });
  const [page, setPage] = useState('1');
  const [isCyclicExeData, setIsCyclicExeData] = useState<boolean>(false);
  const [slaHistory, setSlaHistory] = useState<boolean>(false);
  const [curRow, setCurRow] = useState({} as any);
  const [proInfo, setProInfo] = useState({
    hisProName: '',
    hisSlaTime: '',
    hisProId: '',
    hisSlaDate: '',
  });

  const [startDate, setStartDate] = useState<string>(
    startingDateParam ? moment(startingDateParam).startOf('day').format('YYYY-MM-DD HH:mm') : moment().startOf('day').format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState<string>(
    endingDateParam ? moment(endingDateParam).startOf('day').format('YYYY-MM-DD HH:mm') : moment().endOf('day').format('YYYY-MM-DD'),
  );
  const [selectedDateFilter, setSelectedDateFilter] = useState<string>(dateFilterParam ?? 'Today');

  const kind = 'Pipelines';

  const kindId = kind === 'Pipelines' ? 4 : 1;
  const platformId = jobSchedulesList.length > 0 ? jobSchedulesList[0].platformId : kindId;
  const labels = getPlatformLabels(platformId);
  const defaultColumnNamesPlatformBased = getDefaultColumnNamesExec(platformId);

  let is24Hrs: boolean = false;

  const tabLabel = platformId === 4 ? 'Pipelines' : 'Jobs';
  const [selectedTab, setSelectedTab] = useState(tabLabel);
  const [selectedJobOption, setSelectedJobOption] = useState<string>('predecessor');

  useEffect(() => {
    setSelectedTab(tabLabel);
  }, [tabLabel]);

  useEffect(() => {
    setSelectedJobOption(platformId === 11 ? 'task' : 'predecessor');
  }, [platformId]);

  useEffect(() => {
    if (dateFilterParam) {
      setSelectedDateFilter(dateFilterParam);
    }
  }, [dateFilterParam]);

  const handleDateSelect = (
    stDt: string,
    edDt: string,
    selectedDate?: string,
    is24HrsTime?: boolean,
  ) => {
    // Parse date strings directly in America/Chicago to avoid timezone conversion shifting the date
    const startDate = moment.tz(stDt, 'YYYY-MM-DD HH:mm', 'America/Chicago').format('YYYY-MM-DD');
    const endDate = moment.tz(edDt, 'YYYY-MM-DD HH:mm', 'America/Chicago').format('YYYY-MM-DD');

    setStartDate(startDate);
    setEndDate(endDate);
    setLocalData = false;
    if (projectDetail.JobCount) {
      projectMappedJobScheduleFunc({
        pageNumber: page,
        pageSize,
        startDate,
        endDate,
        filterData: parseFilter(filterInfo),
        sortingInfo,
        filtertype: 'Date',
      });
    }
    const dateRangeFilter = selectedDate ?? selectedDateFilter ?? 'Today';
    setSelectedDateFilter(dateRangeFilter);
    getProjectDetails(dateRangeFilter, startDate, endDate, is24HrsTime);
    if (is24HrsTime !== undefined) {
      is24Hrs = is24HrsTime;
    }
  };

  eventEmitter.on('showSnackbar', (message: string) => {
    setTableLoading(false);
  });

  const fetchCyclicExecutions = (row: any) => {
    setCurRow({ ...row });
    setIsCyclicExeData(true);
  };

  const fetchSlaHistory = (
    hisProId: any,
    hisProName: any,
    hisSlaTime: any,
    hisSlaDate: any,
    dateValue: any,
  ) => {
    let time: any = dateValue ? dateValue : hisSlaDate;
    const isOne = time === 1;
    const isZero = time === 0;
    const isSameDate = moment(time).format('YYYY-MM-DD') === moment(startDate).format('YYYY-MM-DD');
    if (isOne) {
      time = 1;
    } else if (isZero || isSameDate) {
      time = 0;
    } else {
      time = 1;
    }
    setProInfo({ hisProId, hisProName, hisSlaTime, hisSlaDate: time });
    setSlaHistory(true);
  };

  const parseFilter = (filterInfo: any, name?: string) => {
    // Call only filterable columns and reset the filtering in case of wrong/empty column
    const parsedFilter: any = {};
    Object.keys(filterInfo).forEach((key: any) => {
      if (key !== name && filterInfo[key] && filterInfo[key].length) {
        parsedFilter[key] = filterInfo[key];
      }
    });
    return parsedFilter;
  };

  function convertToTimeString(num: any) {
    const hours = Math.floor(num / 100)
      .toString()
      .padStart(2, '0');
    const minutes = (num % 100).toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  const handlePlatformId = (data: any, filterSch: any) => {
    if (data.platformId === 1 && !filterSch.platformId.includes('Teradata')) {
      filterSch.platformId.push('Teradata');
    }
    if (data.platformId === 2 && !filterSch.platformId.includes('BODS')) {
      filterSch.platformId.push('BODS');
    }
  };

  const handleJobStatus = (data: any, filterSch: any) => {
    if (data.jobStatus === 'Successful' && !filterSch.jobStatus.includes('Success')) {
      filterSch.jobStatus.push('Success');
    } else if (data.jobStatus === 'Failure' && !filterSch.jobStatus.includes('Failed')) {
      filterSch.jobStatus.push('Failed');
    } else if (
      data.jobStatus &&
      !['Successful', 'Failure'].includes(data.jobStatus) &&
      !filterSch.jobStatus.includes(data.jobStatus)
    ) {
      filterSch.jobStatus.push(data.jobStatus);
    }
  };

  const handleODate = (data: any, filterSch: any) => {
    const value = moment(data.oDate).tz('America/Chicago').format('MM-DD-YY');
    if (!filterSch.oDate.includes(value)) {
      filterSch.oDate.push(value);
    }
  };

  const handleActualTime = (data: any, filterSch: any) => {
    const start = moment(data.actualStartTime).tz('America/Chicago').format('MM-DD-YY HH:mm');
    const end = moment(data.actualEndTime).tz('America/Chicago').format('MM-DD-YY HH:mm');

    if (!filterSch.actualStartTime.includes(start)) {
      filterSch.actualStartTime.push(start);
    } else if (!filterSch.actualEndTime.includes(end)) {
      filterSch.actualEndTime.push(end);
    }
  };

  const handleSlaTime = (data: any, filterSch: any) => {
    const value = convertToTimeString(data.slaTime);
    if (!filterSch.slaTime.includes(value)) {
      filterSch.slaTime.push(value);
    }
  };

  const handleKind = (data: any, filterSch: any) => {
    const kindValue = getKindFromPlatformId(data.platformId);

    if (kindValue && !filterSch.kind.includes(kindValue)) {
      filterSch.kind.push(kindValue);
    }
  };

  const handleDefault = (data: any, column: string, filterSch: any) => {
    if (data[column] !== undefined && !filterSch[column].includes(data[column])) {
      filterSch[column].push(data[column]);
    }
  };

  const handleAndGetFilterOptions = async (column: any) => {
    let filterSch: any = {};

    if (jobSchedulesList.length) {
      filterSch[column] = [];
      jobSchedulesList.forEach((data: any) => {
        switch (column) {
          case 'platformId':
            handlePlatformId(data, filterSch);
            break;

          case 'jobStatus':
            handleJobStatus(data, filterSch);
            break;

          case 'oDate':
            handleODate(data, filterSch);
            break;

          case 'actualStartTime':
          case 'actualEndTime':
            handleActualTime(data, filterSch);
            break;

          case 'slaTime':
            handleSlaTime(data, filterSch);
            break;

          case 'kind':
            handleKind(data, filterSch);
            break;

          default:
            handleDefault(data, column, filterSch);
            break;
        }
      });

      if (column == 'slaTime') {
        let filteredData = [];
        filteredData = filterSch[column].filter((item: any) => typeof item === 'string');
        filterSch[column] = filteredData;
      }

      setFilterOptions(filterSch);
    }
  };

  const handleFilter = (filterData: any) => {
    setFilterInfo(filterData);
    setClickedItem(null);
    // if clear all is triggered -> reset widget filter
		const isClearAll = filterData && Object.values(filterData).every(
			(v: any) => Array.isArray(v) && v.length === 0
		);
		if (isClearAll) {
			setWidgetJobStatus(null); 
		}
    let objData: any = parseFilter(filterData);
    if (Object.keys(objData).includes('slaTime')) {
      objData['slaTime'].map((data: any, index: number) => {
        objData['slaTime'][index] = Number(data.replace(':', ''));
      });
    }

    if (Object.keys(objData).includes('platformId')) {
      objData['platformId'].map((data: any, index: number) => {
        if (data == 'Teradata') objData['platformId'][index] = 1;
        if (data == 'BODS') objData['platformId'][index] = 2;
      });
    }

    if (Object.keys(objData).includes('oDate')) {
      objData['oDate'].map((data: any, index: number) => {
        objData['oDate'][index] = moment(data, 'MM-DD-YY').format('YYYY-MM-DD');
      });
    }

    if (Object.keys(objData).includes('jobName')) {
      let jobFilter: any = [];
      objData['jobName'].map((data: any, index: number) => {
        let jobInfo: any;
        if (typeof data === 'string') {
          jobInfo = jobSchedulesList.find((obj) => obj.jobName == data);
          jobFilter.push({
            id: jobInfo.jobId,
            platformId: jobInfo.platformId,
            name: jobInfo.jobName,
          });
        }
      });
      
      // Added this condition to avoid auto clearing the jobName column filter when choosing the job status filter
      if (jobFilter?.length) {
        objData['jobName'] = jobFilter;
      }
      setNameFilObj({ jobName: objData['jobName'] });
    }

    if (
      !Object.keys(objData).includes('slaTime') &&
      !Object.keys(objData).includes('platformId') &&
      !Object.keys(objData).includes('oDate') &&
      !Object.keys(objData).includes('jobStatus') &&
      !Object.keys(objData).includes('jobName')
    ) {
      projectMappedJobScheduleFunc({
        pageNumber: page,
        pageSize,
        startDate,
        endDate,
        filterData: parseFilter(filterData),
        sortingInfo,
      });
    } else {
      setFilterInfo(objData);
      projectMappedJobScheduleFunc({
        pageNumber: page,
        pageSize,
        startDate,
        endDate,
        filterData: objData,
        sortingInfo,
      });
    }
  };

  let constRows: any = [];
  let setLocalData = false;

  type ExpandLogicParams = {
    row: any;
    rowIndex: number;
    newRows: Row[];
    projectId: number;
    startDate: any;
    endDate: any;
    resourceTypes?: any;
    name: number;
  };

  const expandLogic = async ({
    row,
    rowIndex,
    newRows,
    projectId,
    startDate,
    endDate,
    resourceTypes,
    name,
  }: ExpandLogicParams) => {
    const boxRows: any = localStorage.getItem('depJobExeData');
    const storageRows = boxRows ? JSON.parse(boxRows) : [];
    let hasStrRow = false;
    let children: Row[] = [];
    let childRows: Row[] = [];
    if (!setLocalData) {
      storageRows.filter((strRow: any) => {
        if (
          strRow.jobId == row.jobId &&
          (row.exeId ? strRow.exeId == row.exeId : strRow.oDate == row.oDate) &&
          strRow.projectId == Number(projectId)
        ) {
          hasStrRow = true;
          newRows.splice(Number(rowIndex) + 1, 0, ...strRow.children);
          newRows[rowIndex] = { ...row, isExpanded: !row.isExpanded, children: strRow.children };
          const newUpdatedRows = [...newRows];
          constRows = newUpdatedRows;
          setjobSchedulesList(newUpdatedRows);
        }
      });
      if (!hasStrRow) {
        let payload = jobSchedulesList.filter((data) => data.id === name);

        setDependentInfoLoading(true);
        const res = await getDependentJobExeData({
          ...payload[0],
          startDate,
          endDate,
          selectedJobOption
        });
        setLocalData = true;
        setDependentInfoLoading(false);
        if (res.success) {
          res.data['dependInfo'] = res.data.depDataResult;

          Object.entries(res.data).forEach(([key, value]: any) => {
            childRows = dependInfoTransformData(value);
          });
          children = childRows.map((x: any) => {
            return { ...x, isChildren: true };
          });
          newRows.splice(Number(rowIndex) + 1, 0, ...children);
          newRows[rowIndex] = { ...row, isExpanded: !row.isExpanded, children };
          const newUpdatedRows = [...newRows];

          constRows = newUpdatedRows;
          setjobSchedulesList(newUpdatedRows);
          const stBoxRows: any = localStorage.getItem('depJobExeData');
          const tempRows = [
            {
              jobId: row.jobId,
              oDate: row.oDate,
              exeId: row.exeId || '',
              projectId: Number(projectId),
              children: children,
            },
          ];
          if (stBoxRows) {
            let tempStorageBoxRows = JSON.parse(stBoxRows);
            tempStorageBoxRows = tempStorageBoxRows.concat(tempRows);
            localStorage.setItem('depJobExeData', JSON.stringify(tempStorageBoxRows));
          } else {
            localStorage.setItem('depJobExeData', JSON.stringify(tempRows));
          }
        }
      }
      if (resourceTypes?.length > 0) {
        childRows = resourceTypes;
      }
      children = childRows.map((x: any) => {
        return { ...x, isChildren: true };
      });
      newRows.splice(Number(rowIndex) + 1, 0, ...children);
      newRows[rowIndex] = { ...row, isExpanded: true, children };
    }
  };

  async function toggleSubRow(name: number, resourceTypes: any, eleLevel: string) {
    const rows = constRows.length ? constRows : jobSchedulesList;
    const rowIndex = rows.findIndex((r: any) => r.id === name);
    const row = rows[rowIndex];
    const newRows = [...rows];

    if (!row.isExpanded) {
      expandLogic({
        name,
        resourceTypes,
        row,
        rowIndex,
        newRows,
        projectId: Number(projectId),
        startDate,
        endDate,
      });
      return;
    }

    let children = row.children ?? [];
    newRows.splice(Number(rowIndex) + 1, children.length);
    newRows[rowIndex] = { ...row, isExpanded: false };
    const newUpdatedRows = [...newRows];

    constRows = newUpdatedRows;
    setjobSchedulesList(newUpdatedRows);
    row.isExpanded = false;
  }

  const [pageSize, setPageSize] = useState('100');

  // Dropdown options
  const getDropdownOptions = () => {
    return [
      { value: 'predecessor', label: 'Show Predecessor', isDisabled: false },
      { value: 'task', label: 'Show Task', isDisabled: false },
    ];
  };

  // Dropdown change
  const handleHeaderDropdownChange = (value: string) => {
    setSelectedJobOption(value);
  };

  const handleSaveComment = async (
    text: string,
    jobId: any,
    jobExeId: any,
    projectId: any,
    platformId: any,
    rowData: any,
  ): Promise<void> => {
    try {
      const response = await postJobComment(projectId, jobExeId, jobId, text, platformId, rowData);
      if (response.success) {
        await projectMappedJobScheduleFunc({
          pageNumber: page,
          pageSize,
          startDate,
          endDate,
          filterData: parseFilter(filterInfo),
          sortingInfo,
        });
      }
    } catch (error) {
      console.error('Error updating comment:', error);
    }
  };

  const renderEditableCell = (
    props: any,
    isAllowed: boolean,
    onSave: (
      text: string,
      jobId: any,
      jobExeId: any,
      projectId: any,
      platformId: any,
      rowData: any,
    ) => Promise<void>,
  ) => {
    const { row } = props;

    return (
      <EditableCell
        jobId={row.jobId}
        jobExeId={row.jobExeId || row.jobRunId}
        projectId={row.projectId}
        comment={row.comment}
        platformId={row.platformId}
        isAllowed={isAllowed}
        textColor={theme.palette.textLight.main}
        onSave={onSave}
        rowData={row}
      />
    );
  };

  function getColumns(): Array<Column<Row>> {
    const columns: Array<Column<Row>> = [];

    // Platform
    columns.push({
      key: 'platformId',
      name: 'Platform',
      formatter: platformIdFormatter(),
      minWidth: 120,
    });

    // ADF
    if (platformId === 4) {
      columns.push({
        key: 'adfName',
        name: 'ADF Name',
        formatter: adfNameFormatter(),
        minWidth: 130,
      });
    }

    // DBSQL
    if (platformId === 11) {
      columns.push(
        {
          key: 'workspaceName',
          name: `${labels.adbWorkspace} Name`,
          formatter: workspaceNameFormatter(),
          minWidth: 200,
          maxWidth: 500,
        },
      );
    }

    // Job name
    columns.push({
      key: 'jobName',
      name: labels.name,
      formatter: jobNameFormatter(toggleSubRow),
      minWidth: 300,
    });

    if (platformId === 11) {
      columns.push(
        {
          key: 'sourceTable',
          name: 'Source Table',
          formatter: sourceTableFormatter(),
          minWidth: 200,
          maxWidth: 500,
        },
        {
          key: 'targetTable',
          name: 'Target Table',
          formatter: targetTableFormatter(),
          minWidth: 200,
          maxWidth: 500,
        },
        {
          key: 'jobRunUrl',
          name: 'JOB Run URL',
          formatter: jobRunUrlFormatter(),
          minWidth: 200,
          maxWidth: 500,
        },
      );
    }

    // File based
    if (platformId === 8) {
      columns.push(
        {
          key: 'runFile',
          name: 'Run File',
          formatter: runFileFormatter(),
          minWidth: 130,
        },
        {
          key: 'filePath',
          name: 'File Path',
          formatter: filepathFormatter(),
          minWidth: 130,
        },
      );
    }

    // Kind
    columns.push({
      key: 'kind',
      name: 'Kind',
      formatter: kindFormatter(),
      minWidth: 150,
    });

    // ADF extra
    if (platformId === 4) {
      columns.push(
        {
          key: 'triggerName',
          name: 'Trigger Name',
          formatter: triggerNameFormatter(),
          minWidth: 130,
        },
      );
    }

    // Folder platforms
    if ([1, 2, 3, 7].includes(platformId)) {
      columns.push(
        {
          key: 'folderNames',
          name: 'Folder Name',
          formatter: folderNamesFormatter(),
          minWidth: 130,
        },
        {
          key: 'subFolderNames',
          name: 'Subfolder Name',
          formatter: subFolderNamesFormatter(),
          minWidth: 130,
        },
      );
    }

    // ADF extra
    if (platformId === 4) {
      columns.push(
        {
          key: 'dataAssetName',
          name: 'Data Asset Name',
          formatter: dataAssetNameFormatter(),
          minWidth: 130,
        },
        {
          key: 'silverTableName',
          name: 'Silver Table Name',
          formatter: silverTableNameFormatter(),
          minWidth: 130,
        },
      );
    }

    // Schedule
    columns.push({
      key: 'scheduleInfo',
      name: 'Schedule Info',
      formatter: scheduleInfoFormatter(),
      minWidth: 200,
      maxWidth: 500,
    });

    // Run / step details
    if (platformId === 4) {
      columns.push({
        key: 'jobRunId',
        name: 'Pipeline Run ID',
        formatter: jobRunIdFormatter(),
        minWidth: 150,
      });
    }

    if (platformId === 10) {
      columns.push(
        {
          key: 'jobRunId',
          name: 'Run ID',
          formatter: runIdFormatter(),
          minWidth: 150,
        },
        {
          key: 'stepId',
          name: 'Step ID',
          formatter: stepIdFormatter(),
          minWidth: 150,
        },
        {
          key: 'stepName',
          name: 'Step Name',
          formatter: stepNameFormatter(),
          minWidth: 150,
        },
      );
    }

    // Job status, Order Date
    columns.push(
      {
      key: 'jobStatus',
      name: labels.status,
      formatter: jobStatusFormatter(),
      minWidth: 200,
      },
      {
        key: 'oDate',
        name: 'Order Date',
        formatter: orderDateFormatter(),
        minWidth: 130,
      },
    );

    // Job condition
    if (platformId === 1) {
      columns.push({
        key: 'jobCondition',
        name: labels.condition,
        formatter: jobConditionFormatter(),
        minWidth: 150,
      });
    }

    // Time based (custom vs ADF)
    if (platformId === 4) {
      columns.push(
        {
          key: 'actualStartTime',
          name: 'Act. Start Time (CST)',
          formatter: actualStartTimeFormatter(),
          minWidth: 200,
        },
        {
          key: 'actualEndTime',
          name: 'Act. End Time (CST)',
          formatter: actualEndTimeFormatter(),
          minWidth: 200,
        },
        {
          key: 'avgRunTime',
          name: 'Avg. Exec. Time',
          formatter: avgRunTimeFormatter(),
          minWidth: 130,
        },
        {
          key: 'totalExecutions',
          name: 'Total Exec.',
          formatter: totalExecutionsFormatter(fetchCyclicExecutions),
          minWidth: 160,
        },
      );
    }

    if ([1, 2, 3, 7, 8, 9, 10, 11].includes(platformId)) {
      columns.push(
        {
          key: 'actualStartTime',
          name: 'Act. Start Time (CST)',
          formatter: actualStartTimeFormatterCustom(),
          minWidth: 200,
        },
        {
          key: 'actualEndTime',
          name: 'Act. End Time (CST)',
          formatter: actualEndTimeFormatterCustom(),
          minWidth: 200,
        },
        {
          key: 'avgRunTime',
          name: 'Avg. Exec. Time',
          formatter: avgRunTimeFormatterCustom(),
          minWidth: 130,
        },
        {
          key: 'totalExecutions',
          name: 'Total Exec.',
          formatter: totalExecutionsFormatterCustom(fetchCyclicExecutions),
          minWidth: 160,
        },
      );
    }

    // Trend + cyclic
    columns.push(
      {
        key: 'execStatusTrend',
        name: 'Last 30 Execution Trend',
        formatter: ragBarFormatter(),
        minWidth: 200,
      },
      {
        key: 'isCyclic',
        name: 'Cyclic',
        formatter: isCyclicFormatter(),
        minWidth: 130,
      },
      {
        key: 'slaStatus',
        name: 'SLA Status',
        formatter: oDateFormatter(),
        minWidth: 130,
      },
      {
        key: 'comment',
        name: 'Comments',
        resizable: false,
        minWidth: 200,
        formatter(props: any) {
          return renderEditableCell(props, isAllowed, handleSaveComment);
        },
        cellClass: 'highlight-cell',
      },
    );

    return columns;
  }

  let slaTimeObj = {
    slaTime: '',
    slaDate: 0,
  };
  useEffect(() => {
    document.body.classList.add('v2Background');
    const activeId = document.getElementById('root');
    if (window.location.pathname.includes('/data-pipeline/ibp-dashboard/projects')) {
      if (activeId) {
        document.head.classList.add('theme-bg-blue');
        document.body.classList.add('theme-bg-blue');
      }
    }

    if (!projectDetail?.Project_Id) {
      const resolvedDateFilter = dateFilterParam ?? 'Today';
      if (!startingDateParam || !endingDateParam) return;
      const st = moment(startingDateParam).tz('America/Chicago').format('YYYY-MM-DD');
      const ed = moment(endingDateParam).tz('America/Chicago').format('YYYY-MM-DD');
      const isSameDay = st === ed;
      getProjectDetails(isSameDay ? st : resolvedDateFilter, st, ed, !isSameDay);
      const newFilter = { ...filterInfo, jobStatus: [] };
      setFilterInfo(newFilter);
      getAddedScheduleList(newFilter);
    }
    localStorage.removeItem('job-schedules-1_user_col_pref'); //Reset the user column preferences
  }, []);


  // Auto-refresh data every 5 mins (refetch API)
  useEffect(() => {
    let mounted = true;

    const refreshData = async () => {
      if (!mounted) return;
      try {
        await getProjectDetails();

        await getAddedScheduleList(filterInfo);
      } catch (err) {
        console.error('Auto-refresh failed', err);
      }
    };

    const id = setInterval(refreshData, 5 * 60 * 1000);

    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, [page, pageSize, startDate, endDate, filterInfo, sortingInfo]);

  const getProjectDetails = async (
    selectedDate?: any,
    stDt?: any,
    edDt?: any,
    isMultipleDate?: boolean,
  ) => {
    setLoading(true);

    let commonDate;
    if (selectedDate && (selectedDate == 'Hrs' || selectedDate == 'Today')) {
      commonDate = stDt;
    } else if (
      selectedDate &&
      (selectedDate == '7d' || selectedDate == '30d' || selectedDate == '3M')
    ) {
      commonDate = moment().tz('America/Chicago').format('YYYY-MM-DD');
    } else if (selectedDate == 'custom') {
      commonDate = isMultipleDate
        ? moment().tz('America/Chicago').format('YYYY-MM-DD')
        : moment(stDt).format('YYYY-MM-DD');
    } else {
      //first time page loading - above if and else if after selecting date filter
      commonDate = moment(startDate).format('YYYY-MM-DD');
    }
    let result = await getProjectById({ projectId, programId, commonDate });

      setLoading(false);

    const projectDetails = result.data?.programData;

    slaTimeObj = {
      slaTime: projectDetails[0].SLA_Time || '',
      slaDate: projectDetails[0].SLA_Date || 0,
    };
    setProjectDetail(projectDetails[0]);
    setSlaStatus(projectDetails[0].SLA_Status);

    if (projectDetails[0].JobCount && selectedDate) {
    } else {
      setLoading(false);
    }
  };

  const getAddedScheduleList = async (newFilter: any, page: number = 1, size: number = 100) => {
    let params = {
      projectId: projectId,
      page,
      size,
    };
    setTableLoading(true)
    let result = await getAddedSchedules(params);
    setTableLoading(false)
    if (result.success) {
      const addedJobs = result?.data?.selectedJobData || [];
      let jobList = addedJobs.map((job: any) => {
        if (job.jobStatus == '--') {
          job.jobStatus = 'Scheduled';
        }
        job.pipeline_trigger_id = job.triggerName
          ? job.jobName + '--' + job.triggerName
          : job.jobName + '--Manual';
        job.isCyclic = job.priCyclic;
        job.triggerName = job.triggerName ? job.triggerName : 'Manual';
        return job;
      });
      setAddedJobsList(jobList);
      const platformName = jobList?.length ? jobList[0].platformName : 'ADF';
      setPlatformName(platformName);  
      if (jobList.length) {
        projectMappedJobScheduleFunc({
          pageNumber: '1',
          pageSize: '100',
          startDate,
          endDate,
          filterData: parseFilter(newFilter),
          sortingInfo,
          jobList,
        });
      }
    }
  };

  const passInfoToParent = (data: any) => {
    getProjectDetails();
  };

  const handleEditClose = (closeType: string) => {
    setOpenModal({
      isOpen: false,
    });
    if (closeType == 'updated') {
      getProjectDetails();
    }
  };


  const handleSorting = (sortingInfo: any) => {
    projectMappedJobScheduleFunc({
      pageNumber: page,
      pageSize,
      startDate,
      endDate,
      filterData: parseFilter(filterInfo),
      sortingInfo,
    });
    setSortingInfo(sortingInfo);
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: string) => {
    setPage(value);
    projectMappedJobScheduleFunc({
      pageNumber: value,
      pageSize,
      startDate,
      endDate,
      filterData: parseFilter(filterInfo),
      sortingInfo,
    });
  };
  const handlepageSizeChange = (event: any) => {
    const pageSize = String(event.target.value);
    setPageSize(pageSize);
    setPage('1');
    projectMappedJobScheduleFunc({
      pageNumber: '1',
      pageSize: pageSize,
      startDate,
      endDate,
      filterData: parseFilter(filterInfo),
      sortingInfo,
    });
  };

  const onClickWidget = (type: string) => {
    let jobStatusParam = type;
    if (type == `Total ${labels.name}`) {
      jobStatusParam = `Total ${labels.name}`;
      setFilterInfo({ jobStatus: [] });
    } else if (type == 'Delayed') {
      jobStatusParam = 'Delayed';
    } else if (type == 'Long Running') {
      jobStatusParam = 'Long Running';
    } else if (type == 'Success') {
      jobStatusParam = 'Success';
    } else if (type == 'Failed') {
      jobStatusParam = 'Failed';
    } else if (type == 'Failed To Start') {
      jobStatusParam = 'Failed To Start';
    }
    setWidgetJobStatus(jobStatusParam);
    const updatedFilter = {
      ...filterInfo,
      jobStatus: jobStatusParam === `Total ${labels.name}` ? [] : [jobStatusParam],
    };
    setFilterInfo(updatedFilter);

    projectMappedJobScheduleFunc({
      pageNumber: '1',
      pageSize,
      startDate,
      endDate,
      filterData: parseFilter(updatedFilter),
      sortingInfo,
    });
  };

  type ProjectMappedJobScheduleParams = {
    pageNumber: string;
    pageSize: string;
    startDate: string;
    endDate: string;
    filterData: any;
    sortingInfo: any;
    filtertype?: string;
    jobList?: any;
  };

  async function projectMappedJobScheduleFunc({
    pageNumber,
    pageSize,
    startDate,
    endDate,
    filterData,
    sortingInfo,
    filtertype,
    jobList,
  }: ProjectMappedJobScheduleParams) {
    setTableLoading(true);

    setLoading(false);
    const addJobsList = addedJobsList?.length ? addedJobsList : [];
    jobList = jobList?.length ? jobList : addJobsList;
    const filterDt = Object.keys(filterOptions) ? filterOptions : filterInfo;
    filterData = Object.keys(filterData) ? filterData : filterDt;
    if (
      filtertype == 'Date' ||
      !Object.keys(filterData).length ||
      !Object.keys(filterData).includes('jobName')
    ) {
      setKpiLoading(true);
    }
    let slaTime = projectDetail?.SLA_Time || slaTimeObj.slaTime || '';
    let slaDate = projectDetail?.SLA_Date || slaTimeObj.slaDate || 0;

    const res = await getMappedJobScheduleList(
      projectId,
      pageNumber,
      pageSize,
      startDate,
      endDate,
      filterData,
      is24Hrs,
      sortingInfo,
      slaTime,
      slaDate,
      jobList,
    );
    if (res.success) {
      let data = res.data.reqResult.slice(
        Number(pageSize) * Number(pageNumber) - Number(pageSize),
        Number(pageSize) * Number(pageNumber) - Number(pageSize) + Number(pageSize),
      );

      data.forEach((result: any) => {
        const match = jobList.find(
          (job: any) =>
            job.pipeline_trigger_id === result.pipeline_trigger_id || job.jobId === result.jobId,
        );

        if (match && match.pipeline_param) {
          result.pipeline_param = match.pipeline_param;
        }
      });

      setTableLoading(false);
      setKpiLoading(false);
      res.data.reqResult.map((datum: any, index: number) => {
        data[index] = { ...datum, id: index + 1 };
      });
      setjobSchedulesList(data);

      setJobExeList(res.data.reqResult);
      if (
        filtertype == 'Date' ||
        !Object.keys(filterData).length ||
        !Object.keys(filterData).includes('jobName')
      ) {
        let objData = {
          slaMet: res.data.kpiData.sla_met,
          slaMissed: res.data.kpiData.sla_missed,
          slaPending: res.data.kpiData.sla_pending,
          completed: res.data.kpiData.success,
          failed: res.data.kpiData.failed,
          longRunning: res.data.kpiData.longRunning,
          scheduled: res.data.kpiData.scheduled,
          delayStart: res.data.kpiData.delayStart,
          failedToStart: res.data.kpiData.failedToStart,
        };

        setSlaReport({
          ...objData,
        });
      }
      setPaginationData(res.data.page);
      setPage(res.data.page.currentPage);
      setPageSize(res.data.page.size);
    }
  }

  async function exportProjectMappedJobScheduleFunc(
    startDate: string,
    endDate: string,
    filterData: any,
    sortingInfo: any,
  ) {
    let exportColumns = [];
    // ADF columns
    if (platformId === 4) {
      exportColumns = [
        'Platform',
        'Kind',
        'Pipeline Name',
        'ADF Name',
        'Trigger Name',
        'Total Exec.',
        'Order Date',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Job Status',
        'Schedule Info',
        'Last 30 Execution Trend',
        'Silver Table Name',
        'Data Asset Name',
      ];
    } else if (platformId === 11) {
      // ADB columns
      exportColumns = [
        'Platform',
        'Workspace Name',
        'Jobs',
        'Source Table',
        'Target Table',
        'JOB Run URL',
        'Schedule Info',
        'Job Status',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Total Exec.',
        'Last 30 Execution Trend',
      ];
    } else if (platformId === 7 || platformId === 3) {
      // MDT/DDH columns
      exportColumns = [
        'Platform',
        'Jobs',
        'Job Status',
        'Schedule Info',
        'Order Date',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Total Exec.',
        'Last 30 Execution Trend',
      ];
    } else if (platformId === 1 || platformId === 2) {
      // BODS/Teradata columns
      exportColumns = [
        'Platform',
        'Jobs',
        'Job Status',
        'Schedule Info',
        'Order Date',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Total Exec.',
        'Last 30 Execution Trend',
        'Folder Name',
        'Subfolder Name',
      ];
    } else if (platformId === 8) {
      // Windows columns
      exportColumns = [
        'Platform',
        'Jobs',
        'Schedule Info',
        'Job Status',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Total Exec.',
        'Last 30 Execution Trend',
      ];
    } else if (platformId === 9) {
      // SAP BW columns
      exportColumns = [
        'Platform',
        'Jobs',
        'Schedule Info',
        'Job Status',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Total Exec.',
        'Last 30 Execution Trend',
      ];
    } else if (platformId === 10) {
      // SQL Server Agent columns
      exportColumns = [
        'Platform',
        'Jobs',
        'Schedule Info',
        'Step ID',
        'Step Name',
        'Job Status',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Total Exec.',
        'Last 30 Execution Trend',
      ];
    } else {
      exportColumns = [
        'Platform',
        'Kind',
        'Jobs',
        'Total Exec.',
        'Cyclic',
        'Order Date',
        'Act. Start Time (CST)',
        'Act. End Time (CST)',
        'Avg Exec. Time',
        'Job Status',
        'Schedule Info',
        'Last 30 Execution Trend',
        'Comments',
      ];
    }
    let formatType = 'EXCEL';
    let tableName = '';
    let slaTime = projectDetail?.SLA_Time || slaTimeObj.slaTime || '';
    let slaDate = projectDetail?.SLA_Date || slaTimeObj.slaDate || 0;
    const filterValue = Object.keys(filterOptions) ? filterOptions : filterInfo;
    filterData = Object.keys(filterData) ? filterData : filterValue;

    if (Object.keys(nameFilObj).includes('jobName')) {
      filterData['jobName'] = [];
      nameFilObj['jobName'].map((data: any, index: number) => {
        let jobInfo: any = jobSchedulesList.find(
          (obj) => obj.jobId == data.id && obj.platformId == data.platformId,
        );
        filterData['jobName'][index] = {
          id: jobInfo.jobId,
          platformId: jobInfo.platformId,
          name: jobInfo.jobName,
        };
      });
    }

    if (widgetJobStatus) {
      if (widgetJobStatus === `Total ${labels.name}`) {
        filterData.jobStatus = [];
      } else {
        filterData.jobStatus = [widgetJobStatus];
      }
    }
    await exportGetMappedJobScheduleList(
      projectId,
      project,
      exportColumns,
      formatType,
      tableName,
      startDate,
      endDate,
      filterData,
      is24Hrs,
      sortingInfo,
      slaTime,
      slaDate,
      null,
      addedJobsList,
    );
  }

  const handleAction = (module: string, type: string, data: any, e: any) => {
    e.preventDefault();
    e.stopPropagation();
    handleMenuClose(e);
    data = {
      ...data,
      ProgramName:
        projectDetail?.program_Name || window.location.pathname.split('/')[5].replace(/%20/g, ' '),
    };
    switch (type) {
      case 'edit':
        setOpenModal({
          isOpen: true,
          type: module,
          action: 'EDIT',
          from: 'edit',
          data: module === 'Project' ? projectDetail : data,
        });
        navigate(
          `/data-pipeline/ibp-dashboard/programs-tab?programID=${programId}&programName=${program}&tab=3&type=Project&isEdited=true&projectID=${projectDetail.Project_Id}`,
        );
        break;
      case 'delete':
        setOpenModal({
          isOpen: true,
          type: module,
          action: 'DELETE',
          from: 'delete',
          data: data,
        });
        break;
      case 'view':
        window.location.href = `/data-pipeline/ibp-dashboard/search-jobs/${programId}/${projectId}/${encodeURIComponent(
          program || '',
        )}/${encodeURIComponent(project || '')}`;
        break;
      default:
        break;
    }
  };

  let slaTime = '';
  let slaDate = 0;
  let encodedSladata = '';
  let linkUrl = '';
  if (projectDetail?.slaData && projectDetail.slaData.length > 0) {
    const fullSlaData = projectDetail.slaData[0];
    encodedSladata = encodeURIComponent(JSON.stringify(fullSlaData));
    linkUrl = `data-pipeline/ibp-dashboard/programs-tab?programID=${programId}&programName=${program}&platform=${platformName}&type=Project&tab=2&projectId=${projectId}&projectName=${project}&isEdited=true&tab=2&sladata=${encodedSladata}`;
  } else {
    slaTime = projectDetail?.SLA_Time ?? '';
    slaDate = projectDetail?.SLA_Date ?? 0;
    linkUrl = `data-pipeline/ibp-dashboard/programs-tab?programID=${programId}&programName=${program}&platform=${platformName}&type=Project&tab=2&projectId=${projectId}&projectName=${project}&isEdited=true&SLA_Time=${slaTime}&SLA_Date=${slaDate}`;
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  const formatSlaTime = (slaTime?: number) => {
    if (slaTime === 0) return '00:00';
    if (!slaTime) return 'NA';
    if (slaTime < 10) return `000${slaTime}`.replace(/(.{2})$/, ':$1');
    if (slaTime < 100) return `00${slaTime}`.replace(/(.{2})$/, ':$1');

    return slaTime.toString().replace(/(.{2})$/, ':$1');
  };

  const loadingLabel = loading ? 'Loading...' : 'NA';

  const STATUS_COLOR_MAP: Record<string, string> = {
    Scheduled: 'paleGray',
    Delayed: 'paleRed',
    'Long Running': 'paleYellow',
    Failed: 'red',
    Success: 'green',
    'Failed To Start': 'purple',
  };

  const getWidgetClassName = (
    title: string,
    clickedItem: string | null,
    hoveredItem: string | null,
    totalLabel: string,
  ) => {
    const isActive = clickedItem === title || hoveredItem === title;

    if (!isActive || title === totalLabel) {
      return 'none';
    }

    return STATUS_COLOR_MAP[title] ?? '';
  };

  const hasData = jobSchedulesList.length > 0;
  const showNoPipelineWidget =
    !tableLoading && jobSchedulesList.length === 0 && projectDetail.JobCount === 0;
  const showFilterInfo =
    !tableLoading && jobSchedulesList.length === 0 && projectDetail.JobCount !== 0;

  const renderProjectSummaryGrid = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} lg={5}>
          <DataInfoSecondary
            infoCards={[
              {
                label: 'Project Name',
                value:
                  projectDetail?.Project_Name?.length > 20
                    ? projectDetail.Project_Name.slice(0, 20) + '...'
                    : projectDetail?.Project_Name,
                isLoading: loading,
                valueProps: {
                  lineHeight: '24px',
                },
              },
              {
                label: 'SLA Time (CST)',
                value: (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body2">
                      {formatSlaTime(projectDetail?.SLA_Time)}
                    </Typography>
                    {projectDetail.isLogsAvailable && (
                      <Grid item xs={2} style={{ display: 'flex', cursor: 'pointer' }}>
                        <ClockIcon
                          style={{ color: 'red', opacity: 1 }}
                          onClick={() =>
                            fetchSlaHistory(
                              projectDetail?.Project_Id,
                              projectDetail?.Project_Name,
                              projectDetail?.SLA_Time,
                              projectDetail?.SLA_Date,
                              projectDetail?.dateValue,
                            )
                          }
                        />
                      </Grid>
                    )}
                  </Stack>
                ),
                isLoading: loading,
                valueProps: {
                  lineHeight: '24px',
                },

                minWidth: '150px',
              },

              {
                label: 'SLA Status',
                value: slaStatus === 'In Progress' ? '' : slaStatus,
                isLoading: tableLoading,
                valueProps: {
                  lineHeight: '24px',
                },
                minWidth: '130px',
              },
            ]}
            infoTooltip={{
              titleValues: [
                {
                  label: 'Alias',
                  value: projectDetail?.Friendly_Name ? projectDetail.Friendly_Name : loadingLabel,
                },
                {
                  label: 'Project Owner',
                  value: projectDetail?.Project_Owner ? projectDetail.Project_Owner : loadingLabel,
                },
                {
                  label: 'Description',
                  value: projectDetail?.Project_Description
                    ? projectDetail.Project_Description
                    : loadingLabel,
                },
                {
                  label: 'Sectors',
                  value: projectDetail?.Sectors ? projectDetail.Sectors : loadingLabel,
                },
              ],
              dateValues: [
                { label: 'Date Created', value: projectDetail?.Created_Dt ?? 'NA' },
                { label: 'Last Updated', value: projectDetail?.Updated_Dt ?? 'NA' },
              ],
            }}
            infoOptionMenu={{
              onClick: handleClick,
              onClose: handleMenuClose,
              menuItems: [
                {
                  key: 'edit',
                  label: 'Edit',
                  icon: <EditIcon />,
                  onMenuClick: (e) => handleAction('Project', 'edit', projectDetail, e),
                },
                {
                  key: 'delete',
                  label: 'Delete',
                  icon: <DeleteIcon />,
                  onMenuClick: (e) => handleAction('Project', 'delete', projectDetail, e),
                },
              ],
            }}
            isAdmin={isAllowed ? true : false}
          />
        </Grid>
        <Grid item container xs={12} lg={7} spacing={1}>
          {[
            {
              title: `Total ${labels.name}`,
              value: projectDetail?.JobCount ? projectDetail?.JobCount : 0,
              isLoading: loading,
              color: '',
            },
            {
              title: 'Scheduled',
              value: slaReport.scheduled || 0,
              isLoading: kpiLoading,
              color: 'paleGray',
            },
            {
              title: 'Failed To Start',
              value: slaReport.failedToStart || 0,
              isLoading: kpiLoading,
              color: 'purple',
            },
            {
              title: 'Delayed',
              value: slaReport.delayStart || 0,
              isLoading: kpiLoading,
              color: 'paleRed',
            },
            {
              title: 'Long Running',
              value: slaReport.longRunning || 0,
              isLoading: kpiLoading,
              color: 'paleYellow',
            },
            {
              title: 'Failed',
              value: slaReport.failed || 0,
              isLoading: kpiLoading,
              color: 'red',
            },
            {
              title: 'Success',
              value: slaReport.completed || 0,
              isLoading: kpiLoading,
              color: 'green',
            },
          ].map(({ title, value, color, isLoading }) => (
            <Grid
              key={title}
              item
              xs={3}
              lg={1.7}
              sm={1.7}
              display="flex"
              className="DataInfo"
              onMouseEnter={() => value && setHoveredItem(title)}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => {
                if (value) {
                  setClickedItem(title);
                  onClickWidget(title);
                }
              }}
            >
              <DataInfoColorWidget
                title={title}
                className={getWidgetClassName(
                  title,
                  clickedItem,
                  hoveredItem,
                  `Total ${labels.name}`,
                )}
                style={{ cursor: value ? 'pointer' : 'default' }}
                onClick={() => value && onClickWidget(title)}
                value={value}
                boxColor={color}
                isLoading={isLoading}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  };

  const renderJobScheduleGrid = () => (
    <>
      {dependentInfoLoading && <Loader />}
      {hasData && !tableLoading && (
        <Stack>
          <Box>
            <CustomizedDataGrid
              tableColumns={getColumns()}
              tableData={jobSchedulesList}
              tableType="job-schedules-1"
              defaultColumnNames={defaultColumnNamesPlatformBased}
              filterDataOptions={filterOptions}
              onSorting={handleSorting}
              currSorting={sortingInfo}
              onFilterCheck={handleFilter}
              currFilter={filterInfo}
              page={page}
              pageSize={pageSize}
              paginationData={paginationData}
              listLength={jobSchedulesList.length}
              handlepageSizeChange={handlepageSizeChange}
              handlePageChange={handlePageChange}
              isDateRangeFilter={false}
              isDisabled={false}
              isFetching={tableLoading}
              showExport={true}
              filterInfo={filterInfo}
              fileName={`Job-details_Page_${paginationData.currentPage}_of_${paginationData.totalPages}.xlsx`}
              exportTableData={() =>
                exportProjectMappedJobScheduleFunc(
                  startDate,
                  endDate,
                  parseFilter(filterInfo),
                  sortingInfo,
                )
              }
              isShowMoreButton
              onFilterClick={handleAndGetFilterOptions}
              dropdownOptions={getDropdownOptions()}
              dropdownValue={selectedJobOption}
              onDropdownChange={handleHeaderDropdownChange}
            />
          </Box>
        </Stack>
      )}
    </>
  );

  return (
    <PageWrapper>
      <Box className={'main-bordered-container'} bgcolor="backgroundLight.primary">
        <PageHeader
          icon={DashboardIcon}
          title={[
            {
              text: 'Programs',
              link: '/data-pipeline/programOps/IBP/markets/ibp-dashboard',
            },
            {
              text: decodeURIComponent(window.location.pathname.split('/')[6]),
              link: `/data-pipeline/ibp-dashboard/programs/${programId}/${window.location.pathname.split('/')[6]}`,
            },
            {
              text: decodeURIComponent(window.location.pathname.split('/')[7]),
            },
          ]}
          childrenContainerProps={{
            minWidth: isAllowed ? '395px' : '230px',
          }}
        >
          <ReactDateRangeFilter
            startingDate={startDate}
            endingDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            handleDateSelect={handleDateSelect}
            initialSelectedDate={dateFilterParam ?? 'Today'}
          />
          {isAllowed && (
            <Link to={linkUrl}>
              <Button variant="pepwiseSecondary" startIcon={<AddIcon />}>
          {`ADD ${labels.name.toUpperCase()}`}
              </Button>
            </Link>
          )}
        </PageHeader>
        <Dialog open={openModal.isOpen} onClose={handleEditClose} fullWidth={true} maxWidth="md">
          <DataPipelineModal
            handleEditClose={handleEditClose}
            programData={openModal}
            passInfoToParent={passInfoToParent}
          />
        </Dialog>

        <Drawer anchor="bottom" open={isCyclicExeData} onClose={() => setIsCyclicExeData(false)}>
          <CyclicExecutions
            startDate={startDate}
            endDate={endDate}
            curRow={curRow}
            setIsCyclicExeData={setIsCyclicExeData}
          />
        </Drawer>
        <Drawer anchor="bottom" open={slaHistory} onClose={() => setSlaHistory(false)}>
          <SLAHistory setSlaHistory={setSlaHistory} proInfo={proInfo} />
        </Drawer>

        <Stack spacing={2} p={2} mt={2}>
          {renderProjectSummaryGrid()}

          {/* Tabs for Pipelines and Jobs */}
          <Box pl={2}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="Platform Tabs"
              textColor="inherit"
              TabIndicatorProps={{
                style: { backgroundColor: '#009BD8', height: '6px', borderRadius: '3px' },
              }}
              sx={{
                mt: 2,
                '& .MuiTabs-flexContainer': {
                  'overflow-x': 'scroll',
                  'overflow-y': 'hidden',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: 'white !important',
                  height: '6px !important', // Thicker underline
                  borderRadius: '3px',
                },
                '& .MuiTab-root': {
                  color: '#F5F5F5 !important',
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  minHeight: '40px',
                  height: '40px',
                  padding: '8px 8px',
                  width: '25vh !important',
                  backgroundColor: '#001e3e !important',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: ' #009BD8 !important',
                  backgroundColor: '#001e3e !important',
                  borderBottom: '10px solid #009BD8 !important',
                },
              }}
            >
              <Tab label={tabLabel} value={tabLabel} />
            </Tabs>

            {selectedTab === 'Pipelines' && (
              <>
                {renderJobScheduleGrid()}
                {showNoPipelineWidget && (
                  <ShowInfoWidget
                    title="No pipelines have been added yet"
                    height="50vh"
                    button="+ ADD Pipeline"
                    onClick={() => {
                      if (isAllowed) {
                        navigate(linkUrl);
                      }
                    }}
                  />
                )}
                {showFilterInfo && (
                  <>
                    <br /> <br />{' '}
                    <Typography textAlign="center">
                      Data will be displayed based on selected filters.
                    </Typography>
                  </>
                )}
                {tableLoading && <Loader />}
              </>
            )}

            {selectedTab === 'Jobs' && (
              <>
                {renderJobScheduleGrid()}
                {showNoPipelineWidget && (
                  <ShowInfoWidget
                    title="No jobs have been added yet"
                    height="50vh"
                    button="+ ADD Job"
                    onClick={() => {
                      if (isAllowed) {
                        navigate(linkUrl);
                      }
                    }}
                  />
                )}
                {showFilterInfo && (
                  <>
                    <br /> <br />{' '}
                    <Typography textAlign="center">
                      Data will be displayed based on selected filters.
                    </Typography>
                  </>
                )}
                {tableLoading && <Loader />}
              </>
            )}
          </Box>
        </Stack>
      </Box>
    </PageWrapper>
  );
};

export default ProjectDetails;
function updateComment(jobId: any, text: string) {
  throw new Error('Function not implemented.');
}